import listOrders from './components/listOrders';
import viewOrderPage from "./components/viewOrderPage";
import productSaleReportPage from "./components/productSaleReportPage";
import orderCreated from "@/modules/orders/components/orderCreated";

export default {
    icon: '',
    url: 'orders',
    name: 'Pedidos',
    routes: [
        {
            path: '/pedidos',
            name: 'orders',
            component: listOrders
        },
        {
            path: '/pedidos/ver/:id',
            name: 'orders.view',
            props: true,
            component: viewOrderPage
        },
        {
            path: '/relatorio/produtos',
            name: 'orders.reports.products',
            component: productSaleReportPage
        },
        {
            path: '/pedido-confirmado/:orderNumber',
            name: 'order.confirmed',
            props: true,
            component: orderCreated
        }
    ]
}